import { ColumnState } from 'ag-grid-community';
import { DateRange } from 'react-day-picker';
import { create } from 'zustand';

import { defaultSAL2020_R01DetailDto, defaultSAL2020_R01HeaderDto, SAL2020_R01DetailDto, SAL2020_R01HeaderDto } from './Dto_SAL2020_R01';

export interface SAL2020_R01Filter {
	compCd: string;
	dateRange: DateRange | undefined;
	customCd: string;
	customNm: string;
}	
export interface Store_SAL2020_R01 {
	SAL2020_R01Filter: SAL2020_R01Filter;
	SAL2020_R01PastFilter: SAL2020_R01Filter;
	setSAL2020_R01Filter: (filter: Partial<Store_SAL2020_R01['SAL2020_R01Filter']>) => void;
	setSAL2020_R01PastFilter: (filter: Store_SAL2020_R01['SAL2020_R01PastFilter']) => void;

	// ====== 매출 리스트 및 선택/편집 ======
	SAL2020_R01List: SAL2020_R01HeaderDto[];
	setSAL2020_R01List: (dataList: SAL2020_R01HeaderDto[]) => void;

	editSAL2020_R01: SAL2020_R01HeaderDto | null;
	setEditSAL2020_R01: (editSale: SAL2020_R01HeaderDto | null) => void;

	selectedSAL2020_R01: SAL2020_R01HeaderDto | undefined;
	setSelectedSAL2020_R01: (data: SAL2020_R01HeaderDto | undefined) => void;
	initSelectedSAL2020_R01: () => void;

	// ====== 상세(디테일) 행 선택/삭제 관리 ======
	deletedSAL2020_R01DetailList: string[];
	setDeletedSAL2020_R01DetailList: (idList: string[]) => void;
	addDeletedSAL2020_R01DetailList: (idList: string[]) => void;
	removeDeletedSAL2020_R01DetailList: (idList?: string[]) => void;

	// ====== 매출 상세(디테일) 데이터 ======
	SAL2020_R01DetailList: SAL2020_R01DetailDto[];
	setSAL2020_R01DetailList: (data: SAL2020_R01DetailDto[]) => void;
	insertSAL2020_R01DetailList: (data: SAL2020_R01DetailDto[], index?: number) => void;
	removeSAL2020_R01DetailList: (index: number) => void;
	updateSAL2020_R01DetailList: (index: number, data: SAL2020_R01DetailDto) => void;

	// ====== 선택(디테일) 행 선택/삭제 관리 ======
	selectedSAL2020_R01DetailList: string[];
	setSelectedSAL2020_R01DetailList: (idList: string[]) => void;
	addSelectedSAL2020_R01DetailList: (idList: string[]) => void;
	removeSelectedSAL2020_R01DetailList: (idList?: string[]) => void;
	initSelectedSAL2020_R01DetailList: () => void;

	originalSAL2020_R01DetailList: SAL2020_R01DetailDto[];
	setOriginalSAL2020_R01DetailList: (data: SAL2020_R01DetailDto[]) => void;

	// ====== 컬럼 상태(그리드) ======
	columnState: ColumnState[] | null;
	setColumnState: (state: ColumnState[] | null) => void;
	detailColumnState: ColumnState[] | null;
	setDetailColumnState: (state: ColumnState[] | null) => void;

	allCount: number;					setAllCount: (allCount: number) => void;
	detailFetchTrigger: boolean;	setDetailFetchTrigger: (trigger: boolean) => void;

	scrollTop: number | null;
	setScrollTop: (top: number | null) => void;
	detailScrollTop: number | null;
	setDetailScrollTop: (top: number | null) => void;

	// ====== 초기화 ======
	initData: () => void;

}

export const defaultSAL2020_R01Filter : SAL2020_R01Filter = {
	compCd: '',
	dateRange: {
		from: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
		to: new Date()
	},
	customCd: '',
	customNm: ''
};

export const useSAL2020_R01Store = create<Store_SAL2020_R01>((set) => ({
	SAL2020_R01Filter: defaultSAL2020_R01Filter,
	SAL2020_R01PastFilter: defaultSAL2020_R01Filter,
	setSAL2020_R01Filter: (update) => set((state) => ({
		SAL2020_R01Filter: {
			...state.SAL2020_R01Filter,
			...update
		}
	})),
	setSAL2020_R01PastFilter: (filter: Store_SAL2020_R01['SAL2020_R01PastFilter']) => set((state) => {
		return {
			...state,
			SAL2020_R01PastFilter: filter
		}
	}),

	// ====== 매출 리스트 및 선택/편집 ======
	SAL2020_R01List: [],
	setSAL2020_R01List: (dataList: SAL2020_R01HeaderDto[]) => set((state) => {
		return {
			...state,
			SAL2020_R01List: dataList
		}
	}),

	editSAL2020_R01: defaultSAL2020_R01HeaderDto,
	setEditSAL2020_R01: (editSale: SAL2020_R01HeaderDto | null) => set((state) => {
		return {
			...state,
			editSAL2020_R01: editSale
		}
	}),

	selectedSAL2020_R01: undefined,
	
	setSelectedSAL2020_R01: (data: SAL2020_R01HeaderDto | undefined) => set((state) => {
		return {
			selectedSAL2020_R01: data,
			selectedSAL2020_R01DetailList: [], deletedSAL2020_R01DetailList: [],
			detailFetchTrigger: true,
			detailScrollTop: null,
		};
	}),
	initSelectedSAL2020_R01: () => set({ selectedSAL2020_R01: undefined, SAL2020_R01DetailList: [], detailFetchTrigger: false }),

	// ====== 매출 상세(디테일) 데이터 ======
	SAL2020_R01DetailList: [],
	setSAL2020_R01DetailList: (data: SAL2020_R01DetailDto[]) => set((state) => {
		const newList = data.map((item, index) => ({
			...item,
			valueIndex: item.valueIndex > 0 ? item.valueIndex : index + 1,
			orderIndex: item.orderIndex > -1 ? item.orderIndex : index + 1,
			orderIndexSeq: item.orderIndexSeq > 0 ? item.orderIndexSeq : 0
		}));
		
		return {
			...state,
			SAL2020_R01DetailList: newList
		};
	}),
	insertSAL2020_R01DetailList: (data: SAL2020_R01DetailDto[], index?: number) => set((state) => {
		let newSAL2020_R01DetailList = [...state.SAL2020_R01DetailList];

		let targetRowData = newSAL2020_R01DetailList.find(item => item.valueIndex === index);
		let targetOrderIndex = targetRowData?.orderIndex || 0;
		// 데이터에 orderIndex가 있으면 그것을 사용하고, 없으면 1 (index 파라미터는 배열 위치로만 사용)		

		const newOrderIndexSeq = (targetRowData?.orderIndexSeq || 0) + 1;
		// console.log('targetOrderIndex : ', targetOrderIndex);
		// console.log('newOrderIndexSeq : ', newOrderIndexSeq);
		let maxValueIndex = Math.max(0, ...newSAL2020_R01DetailList.map(item => item.valueIndex || 0)) + 1;

		// newSYS4100_R01List에서 targetOrderIndex인 행들을 빼내서 newOrderIndexSeq 기준으로 다시 정렬
		// newOrderIndexSeq 보다 orderIndexSeq가 작은 행들은 유지. 
		// newOrderIndexSeq 보다 orderIndexSeq가 큰 행들은 기존 orderIndexSeq 값에 1을 더해서 저장.
		const targetRows = newSAL2020_R01DetailList.filter(item => item.orderIndex === targetOrderIndex);
		targetRows.forEach(item => {
			if(item.orderIndexSeq < newOrderIndexSeq) {
				item.orderIndexSeq = item.orderIndexSeq;
			} else if(item.orderIndexSeq >= newOrderIndexSeq) {
				item.orderIndexSeq = item.orderIndexSeq + 1;
			}
		});

		// targetRows를 newSYS4100_R01List에 대체
		newSAL2020_R01DetailList = newSAL2020_R01DetailList.filter(item => item.orderIndex !== targetOrderIndex);
		newSAL2020_R01DetailList.push(...targetRows);
		
		//새 행을 생성해서 newOrderIndexSeq 값의 행을 저장
		const newData = data.map(item => ({ ...defaultSAL2020_R01DetailDto, ...item, 
			valueIndex: maxValueIndex++,
			orderIndex: targetOrderIndex,
			orderIndexSeq: newOrderIndexSeq
		}));
		if (index !== undefined) {
			newSAL2020_R01DetailList.splice(index, 0, ...newData);
		} else {
			newSAL2020_R01DetailList.push(...newData);
		}

		return {
			...state,
			SAL2020_R01DetailList: newSAL2020_R01DetailList
		}
	}),
	removeSAL2020_R01DetailList: (index: number) => set((state) => {
		const newSAL2020_R01DetailList = [...state.SAL2020_R01DetailList].filter((item) => item.valueIndex !== index);
		return {
			...state,
			SAL2020_R01DetailList: newSAL2020_R01DetailList
		}
	}),
	updateSAL2020_R01DetailList: (valueIndex: number, data: SAL2020_R01DetailDto) => set((state) => {
		const _SAL2020_R01DetailList = state.SAL2020_R01DetailList.map(item =>
			item.valueIndex === valueIndex ? data : item
		);
		return {
			...state,
			SAL2020_R01DetailList: _SAL2020_R01DetailList
		}
	}),
	
	// ====== 상세(디테일) 행 선택/삭제 관리 ======
	deletedSAL2020_R01DetailList: [],
	setDeletedSAL2020_R01DetailList: (idList: string[]) => set((state) => {
		return {
			...state,
			deletedSAL2020_R01DetailList: idList
		}
	}),
	addDeletedSAL2020_R01DetailList: (idList: string[]) => set((state) => {
		const _deletedDetailList = [...state.deletedSAL2020_R01DetailList];

		for(const valueIndex of idList) {
			const isInserted = state.SAL2020_R01DetailList.find(item => item.valueIndex === Number(valueIndex) && item.inserted);
			const isModified = state.SAL2020_R01DetailList.find(item => item.valueIndex === Number(valueIndex) && item.isModified);
			if(!isInserted && !isModified) {
				_deletedDetailList.push(valueIndex);
			}
		}
		
		return {
			...state,
			deletedSAL2020_R01DetailList: _deletedDetailList
		}
	}),
	removeDeletedSAL2020_R01DetailList: (idList?: string[]) => set((state) => ({
		...state,
		deletedSAL2020_R01DetailList: [...state.deletedSAL2020_R01DetailList].filter(value => idList ? !idList.includes(value) : false)
	})),

	selectedSAL2020_R01DetailList: [],
	setSelectedSAL2020_R01DetailList: (idList: string[]) => set((state) => {
		return {
			...state,
			selectedSAL2020_R01DetailList: idList
		}
	}),
	addSelectedSAL2020_R01DetailList: (idList: string[]) => set((state) => {
		const _selectedSAL2020_R01DetailList = [...state.selectedSAL2020_R01DetailList];
		if(idList.length > 0) {
			_selectedSAL2020_R01DetailList.push(...idList);
		}
		return {
			...state,
			selectedSAL2020_R01DetailList: _selectedSAL2020_R01DetailList
		}
	}),
	removeSelectedSAL2020_R01DetailList: (idList?: string[]) => set((state) => ({
		...state,
		selectedSAL2020_R01DetailList: [...state.selectedSAL2020_R01DetailList].filter(value => idList ? !idList.includes(value) : false)
	})),
	initSelectedSAL2020_R01DetailList: () => set({ selectedSAL2020_R01DetailList: [] }),

	originalSAL2020_R01DetailList: [],
	setOriginalSAL2020_R01DetailList: (data: SAL2020_R01DetailDto[]) => set((state) => {
		let newList: SAL2020_R01DetailDto[] = [];
		let valueAndOrderIndex = 1;
		data.forEach((item, index) => {
			newList.push({ 
				...defaultSAL2020_R01DetailDto,
				...item,
				valueIndex: valueAndOrderIndex,
				orderIndex: valueAndOrderIndex,
				orderIndexSeq: valueAndOrderIndex
			});
			valueAndOrderIndex++;
		});
		return {
			...state,
			originalSAL2020_R01DetailList: newList
		}
	}),

	// ====== 컬럼 상태(그리드) ======
	columnState: null,
	setColumnState: (state: ColumnState[] | null) => set({ columnState: state }),
	detailColumnState: null,
	setDetailColumnState: (state: ColumnState[] | null) => set({ detailColumnState: state }),

	allCount: 0,					setAllCount: (allCount: number) => set({ allCount }),
	detailFetchTrigger: false,		setDetailFetchTrigger: (trigger: boolean) => set({ detailFetchTrigger: trigger }),

	scrollTop: null,
	setScrollTop: (top: number | null) => set({ scrollTop: top }),
	detailScrollTop: null,
	setDetailScrollTop: (top: number | null) => set({ detailScrollTop: top }),

	// ====== 초기화 ======
	initData: () => set((state) => ({
		...state,
		SAL2020_R01Filter: defaultSAL2020_R01Filter,
		SAL2020_R01PastFilter: defaultSAL2020_R01Filter,
		SAL2020_R01List: [],
		selectedSAL2020_R01: undefined,
		SAL2020_R01DetailList: [],
		deletedSAL2020_R01DetailList: [],
		selectedSAL2020_R01DetailList: [],
		editSAL2020_R01: defaultSAL2020_R01HeaderDto,
		allCount: 0,
		detailFetchTrigger: false,
		columnState: null,
		detailColumnState: null,
		scrollTop: null,
		detailScrollTop: null,
	})),

	
}));
